export default __webpack_public_path__ + "static/media/chevron-right.c1ceb50e.svg";